import React, { useState, useEffect } from "react";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../store/Slices/CustomerSlice";
import { fetchProducts } from "../../store/Slices/ProductSlice";

const user = JSON.parse(localStorage.getItem("user")) || {};
const branchId = user.branchId || "";

const ItemSummarySelector = ({ SelectedProduct, setSelectedProduct }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [SearchText, setSearchText] = useState("");
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log("Closing popover...");
    setAnchorEl(null); // ✅ Ensures popover closes
  };
  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;

  const dispatch = useDispatch();
  const Products = useSelector((state) => state.ItemsState);

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  return (
    <div className="flex flex-col px-0 gap-y-4">
      <div
        // className="px-4 py-[6px] border-2 border-white rounded-full cursor-pointer bg-[#465462] text-white"
        className={`relative text-left cursor-pointer transition-colors ease-in-out duration-200 border border-line hover:border-main bg-card text-ink px-4 py-3 rounded-lg font-quicksand font-bold text-sm flex gap-x-6 items-center active:scale-[.99]`}
        onClick={handleClick}
      >
        <div className="flex items-center justify-between w-full">
          <div className="w-full outline-none text-left bg-transparent">
            {SelectedProduct === "" ? "Select Item" : SelectedProduct?.name}
          </div>
          <BiSolidChevronDown
            className="text-[1.5rem] cursor-pointer text-muted"
            aria-describedby={id}
            variant="contained"
          />
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "12px",
            backgroundColor: "#ffffff",
            border: "1px solid #E5E9EB",
            width: anchorEl ? anchorEl.offsetWidth : "auto", // 👈 match parent width
            overflow: "hidden",
            marginTop: "4px",
            boxShadow: "0 10px 30px rgba(16,69,70,0.12), 0 2px 8px rgba(16,69,70,0.08)",
            maxHeight: "50vh",
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Typography
          sx={{
            p: 2,
            backgroundColor: "#ffffff",
            overflow: "hidden",
            borderRadius: "12px",
          }}
        >
          <div className="bg-card text-ink font-quicksand flex flex-col justify-center items-center rounded-lg">
            <div className="w-full flex flex-col justify-between gap-y-3 items-start">
              <input
                type="text"
                placeholder="Search"
                name=""
                className="w-full px-3 py-1 rounded-xl text-ink"
                id=""
                value={SearchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <div className="flex flex-col gap-y-1 h-[40vh] overflow-y-auto">
                {Products.data &&
                  [
                    {
                      _id: `all_${branchId}`,
                      name: "All",
                    },
                    ...Products.data,
                  ]
                    .filter((customer) => {
                      if (SearchText === "") {
                        return customer;
                      } else if (
                        customer.name
                          .toLowerCase()
                          .includes(SearchText.toLowerCase())
                      ) {
                        return customer;
                      }
                      return false;
                    })
                    .map((product, i) => {
                      return (
                        <div
                          key={product._id || i}
                          className="flex gap-x-3 items-center cursor-pointer hover:bg-subtle rounded-lg px-2 py-1 transition-colors"
                          onClick={() => {
                            setSelectedProduct(product);
                            handleClose();
                          }}
                        >
                          <input
                            type="checkbox"
                            className="mr-1 h-4 w-4 rounded border border-line accent-main"
                            checked={SelectedProduct?._id === product._id}
                            readOnly
                            onChange={() => {}} // Empty onChange to prevent warning
                          />
                          <span>{product.name}</span>
                        </div>
                      );
                    })}
              </div>
            </div>
          </div>
        </Typography>
      </Popover>
    </div>
  );
};

export default ItemSummarySelector;
